import React from 'react';
import PropTypes from 'prop-types';
import { Icon } from 'antd';
import classnames from 'classnames';

import ModalDrawMap from 'components/ModalDrawMap/ModalDrawMap';

import styles from 'components/Comments/CommentItemAttachments.module.scss';

class CommentItemAttachments extends React.Component {
  state = {
    showDrawMap: false,
  }

  toggleModal = () => {
    this.setState(previousState => ({ showDrawMap: !previousState.showDrawMap }));
  }

  render () {
    const {
      attachment,
      geojson,
      isLink,
      editable,
      selectedActivityUid,
      is_internal: isInternal,
      intersections,
      author,
    } = this.props;
    const { showDrawMap } = this.state;

    if (!attachment && !geojson) {
      return null;
    }

    const itemClassnames = classnames({
      [styles.attachmentListItem]: true,
      [styles['attachmentListItem--link']]: isLink,
    });

    const buttonClassnames = classnames({
      [styles.attachmentButton]: true,
      [styles['attachmentButton--link']]: isLink,
    });

    return (
      <ul className={styles.attachmentList}>
        {attachment && (
          <li className={itemClassnames}>
            <a href={attachment.url} className={buttonClassnames}>
              <Icon type="paper-clip" /> {attachment.name}
            </a>
          </li>
        )}

        {geojson && (
          <li className={itemClassnames}>
            <div className={buttonClassnames}>
              <button type="button" className={styles.attachmentName} onClick={this.toggleModal}>
                <Icon type="environment-o" /> Parcours proposé
              </button>
              {editable && (
                <Icon
                  onClick={this.props.handleRemoveGeojson}
                  type="close"
                  className={styles.attachmentRemove}
                />
              )}
            </div>

            {showDrawMap && (
              <ModalDrawMap
                author={author}
                geojson={geojson}
                selectedActivityResponseUid={selectedActivityUid}
                visible={showDrawMap}
                closeModal={this.toggleModal}
                editable={editable}
                isInternal={isInternal}
                intersections={intersections}
              />
            )}
          </li>
        )}
      </ul>
    );
  }
}

CommentItemAttachments.propTypes = {
  attachment: PropTypes.shape({
    url: PropTypes.string,
    name: PropTypes.string,
  }),
  geojson: PropTypes.object,
  isLink: PropTypes.bool,
  editable: PropTypes.bool,
  is_internal: PropTypes.bool,
  intersections: PropTypes.object,
};

CommentItemAttachments.defaultProps = {
  attachment: null,
  geojson: null,
  isLink: true,
  editable: false,
  is_internal: false,
  intersections: {},
};

export default CommentItemAttachments;



// WEBPACK FOOTER //
// ./src/components/Comments/CommentItemAttachments.js